import { debugLog } from '../utils/debug';
import { ledger, entries } from './CustomFunctions';

// Excel calls with the formula name, fourteen parameters and the invocation (requiresAddress).
type BifrostFormulaFn = (...args: never[]) => Promise<number | string | (string | number | null)[][]>;

declare const CustomFunctions: {
  associate(name: string, fn: BifrostFormulaFn): void;
};

CustomFunctions.associate("BIFROST_LEDGER", ledger);
CustomFunctions.associate("BIFROST_ENTRIES", entries);

Office.onReady(() => {
  debugLog('Bifrost: Custom Functions runtime ready');
});
